export enum TransmissionCategoryKeys {
  Boundaries = 'BoundariesComponent',
  NoBoundaries = 'NoBoundariesComponent',
  LarsAndSworps = 'LarsSworpsComponent',
}
